import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "channel-service-link--header q-mb-xs" }
const _hoisted_2 = {
  key: 0,
  class: "text-subtitle"
}
const _hoisted_3 = {
  key: 1,
  class: "app-list full-width q-px-md q-my-lg"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "app-card--container" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["data-tooltip"]
const _hoisted_8 = { class: "text-caption italic" }
const _hoisted_9 = { class: "row q-mt-sm justify-end app-props app-card--props" }
const _hoisted_10 = { class: "q-pl-none q-ma-none" }
const _hoisted_11 = { class: "q-pl-none q-ma-none" }
const _hoisted_12 = { class: "q-py-xs q-px-sm" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "q-py-xs q-px-sm" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "q-py-xs q-px-sm" }
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 5,
  class: "channel-service-link--link-steps"
}
const _hoisted_25 = { class: "channel-service-link--link-step" }
const _hoisted_26 = {
  key: 0,
  class: "channel-service-link--link-step-input"
}
const _hoisted_27 = {
  key: 1,
  class: "channel-service-link--link-step-bool row items-center"
}
const _hoisted_28 = { class: "text" }
const _hoisted_29 = {
  key: 0,
  style: {"font-weight":"500"}
}
const _hoisted_30 = {
  key: 1,
  style: {"font-weight":"500"}
}
const _hoisted_31 = { class: "radio-tooltip row items-center" }
const _hoisted_32 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_33 = {
  key: 2,
  class: "channel-service-link--link-step-input"
}
const _hoisted_34 = {
  key: 3,
  class: "channel-service-link--link-step-text"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "errors" }
const _hoisted_38 = { class: "channel-service-link--actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_info_button = _resolveComponent("info-button")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    class: "channel-service-link",
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:modelValue',$event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["channel-service-link--container", {'step--link-steps': _ctx.isNextPressed }]),
        style: _normalizeStyle(!_ctx.isNextPressed ? 'overflow-y: clip' : '')
      }, {
        default: _withCtx(() => [
          _createElementVNode("header", _hoisted_1, _toDisplayString(_ctx.isNextPressed ? 'Enter your ' + _ctx.service.label + ' credentials' : 'Select an app'), 1),
          (!_ctx.isNextPressed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "You will be guided through the connection process"))
            : _createCommentVNode("", true),
          (!_ctx.isNextPressed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceOptions, (_service) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["div app-card col-6 rounded-borders", { 'selected': (_ctx.service && _service.label === _ctx.service.label) }]),
                    onClick: () => _ctx.selectService(_service)
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "app-card--logo",
                        style: _normalizeStyle({borderColor: _service.color})
                      }, [
                        _createVNode(_component_q_avatar, {
                          size: "xl",
                          rounded: "",
                          bordered: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _service.logo,
                              "object-fit": "contain",
                              alt: _service.label
                            }, null, 8, _hoisted_6)
                          ]),
                          _: 2
                        }, 1024)
                      ], 4),
                      _createElementVNode("div", {
                        class: "q-ml-md app-card--head has-tooltip",
                        "data-tooltip": _service?.label
                      }, [
                        _createElementVNode("h5", null, _toDisplayString(_service?.label), 1),
                        _createElementVNode("p", _hoisted_8, "API " + _toDisplayString(_service?.apiVersion), 1)
                      ], 8, _hoisted_7),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("ul", _hoisted_10, [
                          _createElementVNode("ul", _hoisted_11, [
                            _createElementVNode("li", _hoisted_12, [
                              (_service.order === 'two-way')
                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 0,
                                    class: "q-pr-md icon-double"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: require('@/assets/icons/essential/103-left-arrow.svg'),
                                        alt: "left arrow"
                                      }, null, 8, _hoisted_13),
                                      _createElementVNode("img", {
                                        src: require('@/assets/icons/essential/102-right-arrow.svg'),
                                        alt: "right arrow"
                                      }, null, 8, _hoisted_14)
                                    ]),
                                    _: 1
                                  }))
                                : (_service.order === 'one-way')
                                  ? (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 1,
                                      class: "q-pr-md"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: require('@/assets/icons/essential/102-right-arrow.svg'),
                                          alt: "right arrow"
                                        }, null, 8, _hoisted_15)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 2,
                                      class: "q-pr-md"
                                    })),
                              _cache[7] || (_cache[7] = _createTextVNode("Order"))
                            ]),
                            _createElementVNode("li", _hoisted_16, [
                              (_service.product === 'two-way')
                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 0,
                                    class: "q-pr-md icon-double"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: require('@/assets/icons/essential/103-left-arrow.svg'),
                                        alt: "left arrow"
                                      }, null, 8, _hoisted_17),
                                      _createElementVNode("img", {
                                        src: require('@/assets/icons/essential/102-right-arrow.svg'),
                                        alt: "right arrow"
                                      }, null, 8, _hoisted_18)
                                    ]),
                                    _: 1
                                  }))
                                : (_service.product === 'one-way')
                                  ? (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 1,
                                      class: "q-pr-md"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: require('@/assets/icons/essential/102-right-arrow.svg'),
                                          alt: "right arrow"
                                        }, null, 8, _hoisted_19)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 2,
                                      class: "q-pr-md"
                                    })),
                              _cache[8] || (_cache[8] = _createTextVNode("Product"))
                            ]),
                            _createElementVNode("li", _hoisted_20, [
                              (_service.inventory === 'two-way')
                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 0,
                                    class: "q-pr-md icon-double"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: require('@/assets/icons/essential/103-left-arrow.svg'),
                                        alt: "left arrow"
                                      }, null, 8, _hoisted_21),
                                      _createElementVNode("img", {
                                        src: require('@/assets/icons/essential/102-right-arrow.svg'),
                                        alt: "right arrow"
                                      }, null, 8, _hoisted_22)
                                    ]),
                                    _: 1
                                  }))
                                : (_service.inventory === 'one-way')
                                  ? (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 1,
                                      class: "q-pr-md"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: require('@/assets/icons/essential/102-right-arrow.svg'),
                                          alt: "right arrow"
                                        }, null, 8, _hoisted_23)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 2,
                                      class: "q-pr-md"
                                    })),
                              _cache[9] || (_cache[9] = _createTextVNode("Inventory"))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ], 10, _hoisted_4))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isNextPressed)
            ? (_openBlock(), _createBlock(_component_q_separator, {
                key: 2,
                class: "dark full-width"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isNextPressed)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "text-subtitle q-my-md underline text-center cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExistingService = !_ctx.isExistingService))
              }, _cache[10] || (_cache[10] = [
                _createTextVNode("OR "),
                _createElementVNode("br", null, null, -1),
                _createElementVNode("br", null, null, -1),
                _createTextVNode(" Use a custom / existing service")
              ])))
            : _createCommentVNode("", true),
          (!_ctx.isNextPressed && _ctx.isExistingService && _ctx.activeServices)
            ? (_openBlock(), _createBlock(_component_form_select, {
                key: 4,
                class: "col-8 q-mt-md",
                "model-value": _ctx.existingService,
                type: "select",
                onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleExistingServiceSelect($event))),
                label: "Existing Services",
                placeholder: "Choose existing services",
                options: _ctx.activeServices
              }, null, 8, ["model-value", "options"]))
            : _createCommentVNode("", true),
          (_ctx.isNextPressed && !_ctx.exisitingService)
            ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SERVICE_DESCRIPTIONS[_ctx.service?.value], (step) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (step.type === 'input')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createVNode(_component_form_input, {
                            label: step.label || step.field,
                            "model-value": _ctx.input[step.field],
                            "onUpdate:modelValue": ($event: any) => (_ctx.input[step.field] = $event)
                          }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (step.type === 'bool')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            (_ctx.input[step.field] === undefined ? step.defaultValue : _ctx.input[step.field])
                              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(step.trueBody), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(step.falseBody), 1))
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_q_toggle, {
                              "model-value": _ctx.input[step.field] === undefined ? step.defaultValue : _ctx.input[step.field],
                              "onUpdate:modelValue": ($event: any) => (_ctx.input[step.field] = $event),
                              dense: ""
                            }, null, 8, ["model-value", "onUpdate:modelValue"]),
                            (step.tooltip)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createVNode(_component_info_button),
                                  _createVNode(_component_q_tooltip, {
                                    style: {"color":"var(--directr__dark-slate-blue)","background-color":"var(--d__blue-lightest)","font-size":"12px"},
                                    anchor: "center left",
                                    self: "top right",
                                    "max-width": "200px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(step.tooltip), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (step.type === 'link')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_ozn_button, {
                            class: "minimal",
                            href: step.url,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(step.label || step.url), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (step.title)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_35, _toDisplayString(step.title), 1))
                            : _createCommentVNode("", true),
                          (step.body)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(step.body), 1))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_37, [
            _withDirectives(_createElementVNode("div", { class: "notice inline-fullwidth error error-label" }, _toDisplayString(_ctx.error.message), 513), [
              [_vShow, _ctx.error.show]
            ])
          ]),
          _createElementVNode("section", _hoisted_38, [
            _createVNode(_component_d_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel())),
              flat: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_close_icon, { left: "" }),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Cancel", -1))
              ]),
              _: 1
            }),
            (_ctx.isNextPressed)
              ? (_openBlock(), _createBlock(_component_d_button, {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = () => _ctx.back()),
                  label: "Back",
                  icon: "arrow_back",
                  color: "primary",
                  rounded: ""
                }))
              : _createCommentVNode("", true),
            (_ctx.isNextPressed || _ctx.existingService.value)
              ? (_openBlock(), _createBlock(_component_d_button, {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = () => _ctx.save()),
                  label: "Save",
                  icon: "check",
                  color: "primary",
                  rounded: ""
                }))
              : _createCommentVNode("", true),
            (!_ctx.isNextPressed && !_ctx.existingService.value)
              ? (_openBlock(), _createBlock(_component_d_button, {
                  key: 2,
                  onClick: _cache[5] || (_cache[5] = () => _ctx.next()),
                  label: "Next",
                  icon: "arrow_forward",
                  color: "primary",
                  rounded: ""
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["style", "class"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}